module.exports = __webpack_public_path__ + "static/101-9693fd2c26f006db86add12ed4c40843.png";